import { render, staticRenderFns } from "./OnboardingSingIn.vue?vue&type=template&id=daa79990&"
import script from "./OnboardingSingIn.vue?vue&type=script&lang=js&"
export * from "./OnboardingSingIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports